import { Link, useLocation } from "react-router-dom";
import logoMetropolis from "../../assets/images/magec.png";
import "./Legal.css";

export default function LegalLayout({ children }) {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="legalPage">
      <header className="legalHeader">
        <Link to="/legal" className="legalHeaderBrand">
          <img src={logoMetropolis} alt="Metropolis" />
          <span>Magec</span>
        </Link>
        <nav className="legalNav">
          <Link to="/legal" className={isActive("/legal") ? "active" : ""}>
            La app
          </Link>
          <Link
            to="/legal/privacidad"
            className={isActive("/legal/privacidad") ? "active" : ""}
          >
            Privacidad
          </Link>
          <Link
            to="/legal/soporte"
            className={isActive("/legal/soporte") ? "active" : ""}
          >
            Soporte
          </Link>
        </nav>
      </header>

      <main className="legalMain">{children}</main>

      <footer className="legalFooter">
        Magec 2026 &middot;{" "}
        <a href="mailto:imetropolis@metropoliscom.com">
          imetropolis@metropoliscom.com
        </a>
      </footer>
    </div>
  );
}
